import { render, staticRenderFns } from "./NTextEditor.vue?vue&type=template&id=635d7060&scoped=true"
import script from "./NTextEditor.vue?vue&type=script&lang=js"
export * from "./NTextEditor.vue?vue&type=script&lang=js"
import style0 from "./NTextEditor.vue?vue&type=style&index=0&id=635d7060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d7060",
  null
  
)

export default component.exports